import request from '../request'
import type { ApiResponse, BindPhoneRequest } from '../types'
import type { UserAssets, UserProfile } from './types'
export * from './types'

/**
 * 获取用户资产
 */
export function memberAssetsApi(): Promise<ApiResponse<UserAssets>> {
  return request.get('/member/assets')
}
/**
 * 获取用户基本信息
 */
export function memberProfileApi(): Promise<ApiResponse<UserProfile>> {
  return request.get('/member/profile/info')
}

/**
 * 校验重置支付密码
 */
export function memberPinResetApi(data: {
  sms_code?: string
  email_code?: string
}): Promise<ApiResponse<{ hash: string }>> {
  return request.post('/member/pin/reset', data)
}
/**
 * 重置支付密码
 */
export function memberPinChangeApi(data: {
  hash: string
  new_pin: string
}): Promise<ApiResponse<{ hash: string }>> {
  return request.post('/member/pin/change', data)
}
/**
 * 设置/修改支付密码
 */
export function memberPinCommitApi(data: {
  /** 旧支付密码验证通过后的 hash */
  hash?: string
  new_pin: string
}): Promise<ApiResponse<{ hash: string }>> {
  return request.post('/member/pin/commit', data)
}
